
const APP_DATA={
  products:[
    {
      id:1,
      title:'Asphalt Plant',
      items:[
        {
          id: 1 ,
          name:'Batching Plants',
          imageUrl:'',
          description:'',
        },
        {
          id: 2 ,
          name:'Continous Plants',
          imageUrl:'',
          description:'',
        },
        {
          id: 3 ,
          name:'Recycling Plants',
          imageUrl:'',
          description:'',
        },
      ]
    },
    {
      id:2,
      title:'Pavers',
      items:[
        {
          id:1,
          name:'Track Changes Pavers',
          imageUrl:'',
          description:'',
        },
        {
          id:2,
          name:'Wheeled Pavers',
          imageUrl:'',
          description:'',
        },
      ]
    },
    {
      id:3,
      title:'Rollers',
      items:[
        {
          id: 1 ,
          name:'Soil Compactors',
          imageUrl:'',
          description:'',
        },
        {
          id: 2 ,
          name:'Tandem Rollers',
          imageUrl:'',
          description:'',
        },
        {
          id: 3 ,
          name:'Rubber Wheeled Rollers',
          imageUrl:'',
          description:'',
        },
      ]
    },
    {
      id:4,
      title:'Road Marking Machines',
      items:[
        {
          id:1,
          name:'Products',
          imageUrl:'',
          description:'',
        },
        {
          id:2,
          name:'Products',
          imageUrl:'',
          description:'',
        },
      ]
    },
    {
      id:5,
      title:'Drilling Equipment',
      items:[
        {
          id:1,
          name:'Products',
          imageUrl:'',
          description:''
        },
        {
          id:2,
          name:'Products',
          imageUrl:'',
          description:''
        },
      ]
    },
    {
      id:6,
      title:'After Sales Service',
      items:[
        
      ]
    }
  ],


  company:{
    name:'Armco Trading',
    phone:'+97 150 324 48 61',
    telefax: '021 - 77 52 49 41',
    email: 'info@armcotrading.de',
    address: 'No. 13022, Opal Tower, Business Bay, 97921, UAE',
    post_code:'161 3944 313'
  },


 slider:[
   {
     id: 0,
     imageUrl:`${require('./assets/slider/asphaltPlant.jpg')}`,
     title:'',
     description:'',
   },
   {
     id: 1,
     imageUrl:`${require('./assets/slider/slider_02.jpeg')}`,
     title:'',
     description:'',
   },
  {
    id: 2,
    imageUrl:`${require('./assets/slider/slider_01.jpeg')}`,
    title:'',
    description:'',
  },
  {
    id: 3,
    imageUrl:`${require('./assets/slider/slider_03.jpeg')}`,
    title:'',
    description:'',
  },
 ],


  faq:[
    {
      id:1,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'0',
    },
    {
      id:2,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'1',
    },
    {
      id:3,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'2',
    },
    {
      id:4,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'3',
    },
    {
      id:5,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'4',
    },
    {
      id:6,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'5',
    },
    {
      id:7,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'6',
    },
    {
      id:8,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'7',
    },
    {
      id:9,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'8',
    },
    {
      id:10,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'9',
    },
    {
      id:11,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'10',
    },
    {
      id:12,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'11',
    },
    {
      id:13,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'12',
    },
    {
      id:14,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'13',
    },
    {
      id:15,
      question:'The Question is asked here',
      answer:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor inreprehenderit in voluptate velit esse cillum dolore eu fugiat nullapariatur. Excepteur sint occaecat cupidatat non proident, sunt inculpa qui officia deserunt mollit anim id est laborum.",
      eventKey:'14',
    },

  ],

  brands:[
    {
      id:1,
      name:'',
      imageUrl:'https://placeimg.com/240/240/any',
    },
    {
      id:2,
      name:'',
      imageUrl:'https://placeimg.com/240/240/any',
    },
    {
      id:3,
      name:'',
      imageUrl:'https://placeimg.com/240/240/any',
    },
    {
      id:4,
      name:'',
      imageUrl:'https://placeimg.com/240/240/any',
    },
  ]
}


export default APP_DATA;